import React, { FC } from 'react';
import { useRouter } from 'next/router';

import NoResults from '../NoResults';
import AppLink from '../AppLink';

import { addParamIfPresent } from '../../utils/querystring';

const TITLE = 'We’re sorry—your search returned 0 results. Try using fewer filters.';

const GenericNoResults: FC = () => {
  const { pathname, query } = useRouter();
  let pageQuery: any = {};
  pageQuery = addParamIfPresent(pageQuery, query, 'slug', pathname.indexOf('slug') > -1);
  pageQuery = addParamIfPresent(pageQuery, query, 'tab');

  return (
    <NoResults className="lg:mr-60" title={TITLE}>
      <AppLink
        className="px-6 py-3.5 tracked-medium text-gatsby border hover:text-dark-blue mb-10"
        href={{
          // Will clear out any pathname data after the slug for pathname filter values (i.e. thematic PLPs)
          // This is to prevent a user from getting trapped with unchangable, bad filter values.
          pathname: pathname.slice(0, pathname.indexOf('[slug]') + 6),
          query: pageQuery,
        }}
        scroll={false}
        tracking={{ id: 'Reset search filters' }}
      >
        Reset filters
      </AppLink>
    </NoResults>
  );
};

export default React.memo(GenericNoResults);
